import React from 'react'
import { useStateValue } from '../state'
import Group from './Group'
import LoadingWave from '../../components/LoadingWave'

const GroupContainer = () => {
  let [currentState] = useStateValue()
  return (
    <React.Fragment>
      {currentState.nestedGroupData.map((nestedGroup, index) => {
        return (
          <Group
            groupId={nestedGroup[0]}
            position={nestedGroup[1]}
            applyGroupWeights={currentState.applyGroupWeights === 'true'}
            key={index}
          />
        )
      })}
      {currentState.loading ? (
        <div className="loading-overlay d-flex justify-content-around align-items-center">
          <LoadingWave />
        </div>
      ) : null}
    </React.Fragment>
  )
}

export default GroupContainer
